import React from 'react';
import { useTheme } from '../context/ThemeContext';

const Header = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  // Use CSS classes instead of inline styles for gradient to avoid issues
  const titleColor = isDarkMode ? '#60a5fa' : '#1d4ed8';

  return (
    <header className="mb-6">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <h1
          className="text-2xl md:text-3xl font-extrabold leading-tight tracking-tight"
          style={{
            color: titleColor,
            flex: '1'
          }}
        >
          {/* MedExpQA Analysis */}
        </h1>

        <button
          onClick={toggleDarkMode}
          className="dark-mode-toggle"
          style={{ marginLeft: 'auto', marginTop: '20px' }}
          aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          <span className="icon sun">☀️</span>
          <span className="icon moon">🌙</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
